import { SET_LOCALESWITCH_VISIBILITY } from '../constants/actionTypes';

export const setLocaleSwitchVisibility = (visible, destCountry = null) => ({
    type: SET_LOCALESWITCH_VISIBILITY,
    visible,
    destCountry
});
